// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".map-control[data-v-4822cb89] {\n  width: 26px;\n  height: 26px;\n  display: inline-block;\n  background-color: #c8e0f5;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.map-control img[data-v-4822cb89] {\n  width: 26px;\n  height: 26px;\n  display: block;\n}\n", ""]);
// Exports
module.exports = exports;
